:host {
  display: inline-block;
  --size: var(--sportsline-team-logo-size, 2.25rem);
}

.sportsline-team-logo {
  float: left;
  width: var(--size);
  height: var(--size);
}

.sportsline-team-logo--small {
  width: var(--sportsline-team-logo-size-small, 1.25rem);
  height: var(--sportsline-team-logo-size-small, 1.25rem);
}

.sportsline-team-logo--medium {
  width: var(--sportsline-team-logo-size-medium, 2.625rem);
  height: var(--sportsline-team-logo-size-medium, 2.625rem);
}

.sportsline-team-logo--large {
  width: var(--sportsline-team-logo-size-large, 3rem);
  height: var(--sportsline-team-logo-size, 3rem);
}

.sportsline-team-logo--extra-large {
  width: var(--sportsline-team-logo-size-extra-large, 3.75rem);
  height: var(--sportsline-team-logo-size-extra-large, 3.75rem);
}
